import { apiUrl } from "../utils/api";

/**
 * Branchen einer Firma nach dem Zwei-Ebenen-Katalog
 * (`/contact/:id/branchengruppen`).
 *
 * Anders als beim dreistufigen Vorgänger steht hier die VOLLSTÄNDIGE Liste —
 * die erste Zeile ist die Hauptbranche. `Contact.branchengruppeId` und
 * `Contact.brancheFreitext` spiegeln sie zusätzlich und laufen über den
 * normalen Kontakt-Speicherweg.
 */
export interface BranchengruppeZuordnung {
  id?: number;
  branchengruppeId: number;
  freitext?: string | null;
  sortIndex?: number;
}

/**
 * Laufende Abfragen je Kontakt. Kopf und Formular der Akte fragen die Branchen
 * beim Öffnen gleichzeitig ab (Befund 28.09.2026) — sie teilen sich dann EINE
 * Anfrage. Nur solange sie läuft: danach fragt jeder Aufruf wieder frisch.
 */
const laufend = new Map<number, Promise<BranchengruppeZuordnung[]>>();

export const branchengruppenLaden = async (
  contactId: number,
): Promise<BranchengruppeZuordnung[]> => {
  let p = laufend.get(contactId);
  if (!p) {
    p = (async () => {
      const res = await fetch(apiUrl(`contact/${contactId}/branchengruppen`), {
        credentials: "include",
      });
      if (!res.ok) throw new Error(`Branchen laden fehlgeschlagen: HTTP ${res.status}`);
      return (await res.json()) as BranchengruppeZuordnung[];
    })();
    laufend.set(contactId, p);
    const weg = () => {
      if (laufend.get(contactId) === p) laufend.delete(contactId);
    };
    p.then(weg, weg);
  }
  // Jeder Aufrufer bekommt seine eigene Kopie — keiner verändert die des anderen.
  const daten = await p;
  return Array.isArray(daten) ? daten.map((z) => ({ ...z })) : daten;
};

/** Ersetzt die Liste vollständig — so schickt sie die Maske auch. */
export const branchengruppenSpeichern = async (
  contactId: number,
  branchengruppen: BranchengruppeZuordnung[],
): Promise<BranchengruppeZuordnung[]> => {
  // Bewusst rohes fetch: apiFetch setzt keinen Content-Type, der JSON-Body käme
  // sonst leer an (siehe firmendatenService).
  const res = await fetch(apiUrl(`contact/${contactId}/branchengruppen`), {
    method: "PUT",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      branchengruppen: branchengruppen.map((b) => ({
        branchengruppeId: b.branchengruppeId,
        freitext: b.freitext ?? null,
      })),
    }),
  });
  if (!res.ok) throw new Error(`Branchen speichern fehlgeschlagen: HTTP ${res.status}`);
  return res.json();
};
